import gql from 'graphql-tag';

export const getPublishedContentAppearanceProperty = gql`
	query getPublishedContentAppearanceProperty($contentId: ID, $status: [String]) {
		content(id: $contentId, status: $status) {
			nodes {
				id
				appearancePublished: properties(key: "content-appearance-published") {
					nodes {
						id
						key
						value
						version {
							number
						}
					}
				}
			}
		}
	}
`;
